import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { TestDriveForm } from "@/components/forms/TestDriveForm";
import { MapView } from "@/components/MapView";
import { MapPin, ArrowRight } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export default function ProvaHub() {
  const { data: locations = [] } = useQuery({ queryKey: ["locations-pub"], queryFn: () => api.get("/locations", { params: { indexable_only: true } }).then((r) => r.data) });

  return (
    <>
      <Seo title="Ordina SENIORCAR — Nella tua città"
        description="Ordina online SENIORCAR con il supporto del centro più vicino a te: a Milano, Roma, Torino e in tutta Italia."
        keywords="ordina seniorcar, dispositivo medico mobilità" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Ordina online" }]} /></div>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-6">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>Ordina SENIORCAR vicino a te</h1>
        <p className="mt-4 text-lg sm:text-xl text-slate-600 max-w-2xl">Scegli la tua città o compila il modulo: ti seguiamo noi fino alla conferma dell'ordine online e alla consegna.</p>
      </section>

      {locations.length > 0 && (
        <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
          <div className="mb-6"><MapView points={locations.map((l) => ({ id: l.slug, lat: l.latitude, lng: l.longitude, title: `SENIORCAR ${l.city}`, subtitle: l.address }))} height={340} /></div>
          <div className="grid sm:grid-cols-3 gap-4">
            {locations.map((l) => (
              <Link key={l.slug} to={`/prova-seniorcar/${l.slug}`} className="rounded-2xl bg-white border border-slate-200 p-5 hover:shadow-md hover:-translate-y-1 transition-all group" data-testid={`prova-city-${l.slug}`}>
                <span className="w-10 h-10 rounded-lg flex items-center justify-center text-white mb-3" style={{ backgroundColor: "var(--sc-emerald)" }}><MapPin size={18} /></span>
                <h3 className="text-lg font-bold text-slate-900 group-hover:text-emerald-800" style={{ fontFamily: "Outfit" }}>Ordina a {l.city}</h3>
                <p className="text-slate-500 text-sm mt-1">{l.dealer_name}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-emerald-800 font-semibold text-sm">Ordina <ArrowRight size={14} /></span>
              </Link>
            ))}
          </div>
        </section>
      )}

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <h2 className="text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Outfit" }}>Ordina online</h2>
        <p className="text-slate-600 mb-6">Non trovi la tua città? Nessun problema: compila il modulo e ti richiamiamo.</p>
        <TestDriveForm />
      </section>
      <div className="h-16" />
    </>
  );
}
